import { useEffect, useState } from 'react';
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';

export const EditorComponent = ({ data, setEditorValue }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    setEditorValue(
      draftToHtml(convertToRaw(newEditorState.getCurrentContent()))
    );
  };

  useEffect(() => {
    setEditorState(() => {
      if (data) {
        const blocksFromHTML = convertFromHTML(data);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );
        return EditorState.createWithContent(contentState);
      }
      return EditorState.createEmpty();
    });

    setEditorValue(data);
  }, [data]);

  return (
    <div className="field_Container width_95">
      <Editor
        toolbar={{
          options: ['inline', 'blockType', 'list'],
          inline: {
            inDropdown: false,
            options: ['bold', 'italic', 'underline', 'strikethrough'],
          },
          list: { inDropdown: false, options: ['unordered', 'ordered'] },
        }}
        editorState={editorState}
        wrapperClassName="editor_wrapper"
        editorClassName="editor_container"
        onEditorStateChange={onEditorStateChange}
      />
    </div>
  );
};
